"use client";

import "./comment.css";

function Comment({ children }) {
  return <div className="comment">{children}</div>;
}

function ProfileImage({ src }) {
  return <img className="profile-image" src={src} alt="profile" />;
}

function Content({ name, text, contentImage, openModal, time, showTime }) {
  const timeStr = time ? `${time[3]}:${String(time[4]).padStart(2, "0")}` : "";
  console.log("showTime", showTime);
  return (
    <>
      <div className="comment-cont">
        <span className="comment-name">{name}</span>
        <div className="comment-content">
          {text}
          {!contentImage && showTime && (
            <span
              style={{
                fontSize: "10px",
                color: "rgba(255, 255, 255, 0.4)",
                marginLeft: "5px",
              }}
            >
              {timeStr}
            </span>
          )}
        </div>
        {contentImage && (
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            <div
              style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}
            >
              {contentImage.map((item) => (
                <div
                  className="content-image"
                  key={item.IMAGESEQ}
                  onClick={() => {
                    openModal(item.IMAGEURL);
                  }}
                >
                  <img
                    className="image"
                    src={item.IMAGEURL}
                    alt="content-image"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
            {showTime && (
              <span
                style={{
                  fontSize: "10px",
                  color: "rgba(255, 255, 255, 0.4)",
                  marginLeft: "5px",
                }}
              >
                {timeStr}
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
}

Comment.ProfileImage = ProfileImage;
Comment.Content = Content;

export default Comment;
